import React, { useState } from "react";
import { withRouter } from "react-router-dom";

import "./Landing.css";

function Landing({ history }) {
    const [slug, setSlug] = useState(null);

    const onSubmit = event => {
        event.preventDefault();

        history.push(slug);
    };

    return (
        <div className="landing-page">
            <div className="title">Codenames: GIFs</div>

            <div className="about">
                Play online across multiple devices on a shared board.
                <br />
                <br />
                To create a new game or join an existing game, enter a game
                identifier and click "GO".
            </div>

            <div className="form-wrapper">
                <form onSubmit={onSubmit}>
                    <input
                        className="form-input"
                        type="text"
                        id="slug"
                        name="slug"
                        autoComplete="off"
                        onChange={e => setSlug(e.target.value)}
                    />

                    <input className="form-submit" type="submit" value="Go" />
                </form>
            </div>
        </div>
    );
}

export default withRouter(Landing);
